import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces'
import { getContractOpportunities } from '../../contracts'

export default function useCustomerOpportunities(
  query: DetailPaginatedRequest
) {
  const { data, error, isLoading } = useQuery(
    ['customerOpportunities', query],
    () => getContractOpportunities(query)
  )
  return { data, error, isLoading }
}
